import { render, staticRenderFns } from "./banner-video.vue?vue&type=template&id=2cea146f&scoped=true&"
import script from "./banner-video.vue?vue&type=script&lang=js&"
export * from "./banner-video.vue?vue&type=script&lang=js&"
import style0 from "./banner-video.vue?vue&type=style&index=0&id=2cea146f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cea146f",
  null
  
)

export default component.exports